import React from 'react';
import {BreadcrumbReact} from "../packages/BreadcrumbReact";

export const ValorantCategoryPageHero = ({ title, description, image, elements }) => {
  return (
    <div className="valorant-category-page__hero">
      <div className="valorant-category-page__text-container">
        <BreadcrumbReact elements={elements} className="mb-4"/>
        <div className="valorant-category-page__text-wrapper">
          <h1 className="valorant-category-page__title text-4xl font-bold leading-none">{title}</h1>
          <p className="valorant-category-page__description">{description}</p>
        </div>
      </div>
      <img src={image} alt="valorant champions" />
    </div>
  );
};
